import TaskStore from '../../../store/TaskStore'
import CustomerStore from '../../../store/CustomerStore'
import ProjectStore from '../../../store/ProjectStore'
import $ from 'jquery'
import ViewTTStore from '../../../user/viewtt/ViewTTStore'
import {customerFromRpc, projectFromRpc} from '../../../taskManagement/utils'
import TaskManagementStore from '../../../taskManagement/TaskManagementStore'

export const afterTaskUpdateCb = (taskId, newData) => {
    const taskFromStore = TaskStore.get(taskId)
    const task = {
        ...taskFromStore,
        ...newData,
    }
    TaskStore.add(task)
    $(document).trigger("editTaskPanel_updateTask", [{taskId, prevTaskState: taskFromStore}]);
}

export const afterTaskLoadedCb = (task) => {
    TaskStore.add(task)
}

export const afterTaskDeleted = (taskId) => {
    $(document).trigger("taskManagement_removeTasks", [[taskId]])
    TaskStore.remove(taskId)
    TaskManagementStore.removeTasks([taskId])
}

export const onProjectDeleted = (projectId) => {
    ProjectStore.remove(projectId)
    $(document).trigger("editTaskPanel_projectDeleted", [{projectId}])
}

export const updateCustomers = (customers) => {
    // TODO: can use CustomerStore.mergeAll
    for (let customer of customers) {
        CustomerStore.add(customerFromRpc(customer))
    }
}

export const updateProjects = (projects) => {
    // TODO: can use ProjectStore.mergeAll
    for (let project of projects) {
        ProjectStore.add(projectFromRpc(project))
    }
}

export const updateCommentsCount = (taskId, commentsCount) => {
    const taskFromStore = TaskStore.get(taskId)
    const task = {
        ...taskFromStore,
        commentsNumber: commentsCount,
    }
    TaskStore.add(task)
}

export const afterTaskMovedCb = (project, customer) => {
    ViewTTStore.setProject(project)
    ViewTTStore.setCustomer(customer)
}



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/syncCallbacks.js